import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const OuterWrapper = styled(Box)(`
    padding-top:10px;
    & .formWrapper {
        max-width: 450px;
    }
`)

export const Error = styled(Box)(`
    font-size:13px;
    color:red;
`)

export const Message = styled(Box)(`
    font-size:13px;
    color:green;
`)
